import { toast } from "react-toastify";
import { SWRConfig } from "swr";

export const withSWR = (children) => () => (
  <SWRConfig
    value={{
      onError: (error) => {
        if (error.response.status == 400 || error.response.status === 401) return;
        if (error.response?.status === 404) {
          toast.warning(error.response?.data?.message ?? error.message, {
            theme: "colored",
          });
        } else {
          toast.error(error.response?.data?.message ?? error.message, {
            theme: "colored",
          });
        }
      },
    }}
  >
    {children()}
  </SWRConfig>
);
